__turbopack_context__.v({
  "circle": "Loading-module-scss-module__6ia4QW__circle",
  "circleContainer": "Loading-module-scss-module__6ia4QW__circleContainer",
  "color-switch": "Loading-module-scss-module__6ia4QW__color-switch",
  "fade": "Loading-module-scss-module__6ia4QW__fade",
  "fade-slide": "Loading-module-scss-module__6ia4QW__fade-slide",
  "label": "Loading-module-scss-module__6ia4QW__label",
  "loadingContainer": "Loading-module-scss-module__6ia4QW__loadingContainer",
  "open-from-center": "Loading-module-scss-module__6ia4QW__open-from-center",
  "spin": "Loading-module-scss-module__6ia4QW__spin",
});
